import ClickOutside from "./clickoutside";

const hooks = { ClickOutside };

export default hooks;
